<template>
    <div>
        <slot></slot>
        <a href='#top' class="faq-back-to-top btn btn-secondary"><i class="fas fa-chevron-up"></i>&nbsp;Back to top</a>
    </div>
</template>

<script>
export default {
    name: 'FaqList',
    props: {},
    data() {
        return {

        };
    },
    methods: {
        scrollTo: function($element, offsetBy) {
            let offset = offsetBy || 120, elementOffset = 0;

            if($('#main-nav').length) {
                elementOffset = $('#main-nav').outerHeight();
            }
            else if($("main > .navbar").length) {
                elementOffset = $("main > .navbar").outerHeight();
            }

            $('html, body').animate({
                scrollTop: $element.offset().top - elementOffset - offset,
            });
        },
        backToTop: function($trigger) {
            $('html, body').animate({
                scrollTop: 0
            });
        },
    },
    mounted() {
        let Component = this;

        let backToTop = $(".faq-back-to-top");
        backToTop.on("click",function(e) {
            e.preventDefault();
            Component.backToTop($(e.target));
        });

        $(".faq-menu-item > a").on("click",function(e) {
            e.preventDefault();
            let targetFaq = $( $(e.target).attr("href") );
            if(!targetFaq.length) {
                return false;
            }

            targetFaq.append(backToTop);

            Component.scrollTo( $( $(e.target).attr("href") ) );
        });

        var scrolling = false;

        $( window ).scroll( function() {
            scrolling = true;
        });

        setInterval( function() {
            if ( scrolling ) {
                scrolling = false;

                if ($(window).scrollTop() >= 100) {
                    $('body').addClass('body-scrolled');

                }
                else {
                    $('body').removeClass('body-scrolled');
                }
            }
        }, 150 );

    }
}
</script>
